module.exports = __webpack_public_path__ + "img/en01.b02081ed.png";